/**
 * 规则事件的唯一标识（B，pet_arcade/core；动作清单 F0 修订 R2 第 2 条，c84a D2134-3）。
 *
 * 每条规则事件带 `round`（第几局：开局 1，每次 restart +1）、`step`（核心步进号：这一局开局以来走了几步，事件发生在哪一步）、
 * `seq`（同一步里的次序，从 0 起）。三样合起来在一个游戏对象里唯一、按发生先后递增：播放器按它去重——
 * 同一个规则事件只切一次段，重渲染、切回前台、重复投递都不重播。
 * 不在推进里发生的事件（开局、暂停、恢复、退出、重来、放绝招）记在当时的步进号上，次序接着这一步已发的往后排。
 */

export interface EventStamp { round: number; step: number; seq: number }

export type Stamped<E> = E & EventStamp;

export interface EventStamper {
  /** 给这一批事件依次盖上 (round, step, seq)；返回新对象，不改原件。 */
  stamp<E extends object>(events: readonly E[], step: number): Stamped<E>[];
  /** 重来：局号 +1，步进号与次序从头算。 */
  nextRound(): void;
  readonly round: number;
}

export function createEventStamper(): EventStamper {
  let round = 1;
  let lastStep = -1;
  let seq = 0;
  return {
    stamp<E extends object>(events: readonly E[], step: number): Stamped<E>[] {
      return events.map((event) => {
        if (step !== lastStep) {
          lastStep = step;
          seq = 0;
        }
        return { ...event, round, step, seq: seq++ };
      });
    },
    nextRound(): void {
      round += 1;
      lastStep = -1;
      seq = 0;
    },
    get round() {
      return round;
    },
  };
}

/** 播放器去重用的键：同一个游戏对象里唯一。 */
export function eventKey(event: EventStamp): string {
  return `${event.round}:${event.step}:${event.seq}`;
}
